import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Chip,
  CardContent,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import LayersIcon from "@mui/icons-material/Layers";

import { StyledCard } from "../common/StyledCard";
import { GradeLevelResponseDto } from "../../shared/dtos/gradeLevel/GradeLevelResponseDto";

interface GradeLevelCardProps {
  gradeLevel: GradeLevelResponseDto;
  onEdit?: () => void;
  onDelete?: () => void;
}

const GradeLevelCard: React.FC<GradeLevelCardProps> = ({
  gradeLevel,
  onEdit,
  onDelete,
}) => {
  return (
    <StyledCard>
      <CardContent
        sx={{
          p: 2,
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        {/* Header: Name, Order Badge, Actions */}
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 1,
          }}
        >
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {gradeLevel.name}
            </Typography>
            <Chip
              icon={<LayersIcon fontSize="small" />}
              label={`Order: ${gradeLevel.levelOrder}`}
              size="small"
              variant="outlined"
              color="secondary"
              sx={{
                mt: 0.5,
                height: 24,
                fontSize: "0.75rem",
                fontWeight: "bold",
              }}
            />
          </Box>

          <Stack direction="row">
            {onEdit && (
              <Tooltip title="Edit Grade Level">
                <IconButton size="small" color="secondary" onClick={onEdit}>
                  <EditOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onDelete && (
              <Tooltip title="Delete Grade Level">
                <IconButton size="small" color="error" onClick={onDelete}>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>

        {/* Divider / Spacer */}
        <Box sx={{ my: 1.5, height: 1, bgcolor: "divider" }} />

        {/* Description */}
        <Box sx={{ flexGrow: 1 }}>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              fontWeight: "bold",
              display: "block",
            }}
          >
            DESCRIPTION
          </Typography>
          <Typography
            variant="body2"
            sx={{
              mt: 0.5,
              color: "text.primary",
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {gradeLevel.description || "No description provided."}
          </Typography>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default GradeLevelCard;
